import { useTheme } from '@mui/material'
import { useState } from 'react'
import colors from 'styles/colors'
import { VictoryLabel } from 'victory'

export const radarGraphLocationString = 'RadarGraph'

const ScoreLabel = ({
  x,
  y,
  attrKey,
  score,
  angle,
  handleMouseChange,
  handleBehaviorNavitation,
  showScoreLabel,
  style,
  ...props
}) => {
  const theme = useTheme()
  const rectW = 30
  const rectH = 7
  const scoreFontSize = 4 // Oddly small number here
  const [hoveredLabel, setHoveredLabel] = useState(false)

  const calculateLabelDx = angle => Math.cos(angle) * 15

  const calculateLabelX = (x, angle) => {
    const isVertical = Math.abs(Math.cos(angle)) < Number.EPSILON
    const isHorizontal = Math.abs(Math.sin(angle)) < Number.EPSILON
    const isRight = Math.cos(angle) > 0

    return isVertical
      ? x
      : isHorizontal && isRight
        ? x + 15
        : isHorizontal
          ? x - 15
          : x + 20 * Math.cos(angle)
  }

  const calculateLabelY = (y, angle, text, verticalAnchor) => {
    const isTopHalf = Math.sin(angle) > 0
    const isHorizontal = Math.abs(Math.sin(angle)) < Number.EPSILON

    const gap = 5.5 + text.length * 2.5
    const wideGap = gap + text.length * 2

    return !isTopHalf && verticalAnchor === 'start'
      ? y + wideGap
      : isHorizontal || !isTopHalf
        ? y + gap
        : isTopHalf && verticalAnchor === 'end'
          ? y - wideGap
          : y - gap
  }

  const calculateBoxY = (y, angle, text, verticalAnchor, scoreFontSize) => {
    const label = calculateLabelY(y, angle, text, verticalAnchor)

    return verticalAnchor === 'start'
      ? label + scoreFontSize / 2
      : verticalAnchor === 'end'
        ? label - scoreFontSize / 2
        : label
  }

  return (
    <g>
      <VictoryLabel
        x={x}
        y={y}
        dx={calculateLabelDx(angle)}
        labelPlacement='vertical'
        style={{
          ...style,
          fill: hoveredLabel ? colors.MidnightTeal400 : style.fill,
          fontSize: hoveredLabel ? style.fontSize + 1 : style.fontSize,
        }}
        {...props}
        events={{
          onClick: () => handleBehaviorNavitation(attrKey),
          onMouseEnter: () => {
            setHoveredLabel(true)
            handleMouseChange('pointer')
          },
          onMouseLeave: () => {
            setHoveredLabel(false)
            handleMouseChange(null)
          }
        }}
      />
      {showScoreLabel && (
        <>
          <rect
            x={calculateLabelX(x, angle) - rectW / 2}
            y={
              calculateBoxY(
                y,
                angle,
                props.text,
                props.verticalAnchor,
                scoreFontSize
              ) -
              rectH / 2
            }
            width={rectW}
            height={rectH}
            fill={colors.White}
            filter='drop-shadow(0px 0px 1px rgba(0,0,0,0.15))'
            rx={1}
          />
          <VictoryLabel
            text={score.toString()}
            style={{
              fill: colors.Teal400,
              fontSize: scoreFontSize,
              fontFamily: theme.typography.fontFamily
            }}
            x={calculateLabelX(x, angle)}
            y={calculateLabelY(y, angle, props.text, props.verticalAnchor)}
            labelPlacement='vertical'
            textAnchor='middle'
            verticalAnchor={props.verticalAnchor}
          />
        </>
      )}
    </g>
  )
}

export default ScoreLabel
